// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main[data-v-607a3e79]{display:flex;flex-direction:column;gap:24px;margin:auto;max-width:1752px;padding-inline:25px}@media(min-width:1050px){.main[data-v-607a3e79]{padding-inline:48px}}.user-profile[data-v-607a3e79]{padding-top:16px}.profile-content[data-v-607a3e79]{display:grid;grid-template-columns:repeat(var(--columns),minmax(0,1fr));grid-auto-rows:minmax(50px,auto);gap:16px}", ""]);
// Exports
module.exports = exports;
